import { render, staticRenderFns } from "./ArticleRelatedHeadline.vue?vue&type=template&id=acb48d52&scoped=true&functional=true&"
import script from "./ArticleRelatedHeadline.vue?vue&type=script&lang=ts&"
export * from "./ArticleRelatedHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleRelatedHeadline.vue?vue&type=style&index=0&id=acb48d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "acb48d52",
  null
  
)

export default component.exports